import React, { Component } from 'react';

//componentes
import ReporteAca from './reporteAca'

class Index extends Component {

    render(){
        return(
            <div>
                <ReporteAca />
            </div>
        );
    }

}
export default Index;